<template>
  <splitpanes class="default-theme">
    <pane min-size="50" size="70">
      <div class="container" ref="container"></div>
    </pane>
    <pane min-size="30" size="30">
      <template v-if="selectType==='node'">
        <el-tabs style="height: 100%;background-color: #FFFFFF;">
          <el-tab-pane label="节点属性">
            <el-form label-width="120px" v-model="jsonData">
              <el-form-item label="节点code" required>
                <el-input v-model="selectElement.code" placeholder="节点code,必须唯一" autosize maxlength="36"></el-input>
              </el-form-item>
              <el-form-item label="节点名称" required>
                <el-input type="textarea" v-model="selectElement.text" placeholder="节点名称" autosize maxlength="20"></el-input>
              </el-form-item>
              <el-form-item label="触发器(进)" v-if="selectElement.type!='node_start'" >
                <el-cascader v-model="selectElement.in_triggers" :options="programTree" style="width: 100%"
                             :show-all-levels="false" placeholder="进节点的触发器" :props="cascaderPropsMulti" clearable multiple filterable>
                </el-cascader>
              </el-form-item>
              <el-form-item label="触发器(出)" v-if="selectElement.type!='node_end'">
                <el-cascader v-model="selectElement.out_triggers" :options="programTree" style="width: 100%"
                             :show-all-levels="false" placeholder="出节点的触发器" :props="cascaderPropsMulti" clearable multiple filterable>
                </el-cascader>
              </el-form-item>
              <el-form-item label="触发器(撤销)" v-if="selectElement.type!='node_start' && selectElement.type!='node_end'">
                <el-cascader v-model="selectElement.revoke_triggers" :options="programTree" style="width: 100%"
                             :show-all-levels="false" placeholder="撤销流程的触发器" :props="cascaderPropsMulti" clearable multiple filterable>
                </el-cascader>
              </el-form-item>
              <el-form-item label="会签节点"  v-if="selectElement.type!='node_start' && selectElement.type!='node_end'">
                <el-switch v-model="selectElement.multi"></el-switch>
                <span style="margin-left: 10px;font-size: smaller;color: grey">任务同时发给多个部门</span>
              </el-form-item>
              <el-form-item label="部门数据源"  v-if="selectElement.type!='node_start' && selectElement.type!='node_end'">
                <el-input v-model="selectElement.data_key_multi_departments" placeholder="例如node_create.department_ids"  maxlength="128"></el-input>
              </el-form-item>
              <el-form-item label="流程发起人" v-if="selectElement.type!='node_start' && selectElement.type!='node_end'">
                <el-switch v-model="selectElement.assign_to_creator"></el-switch>
                <span style="margin-left: 10px;font-size: smaller;color: grey">指定流程的发起人执行此任务</span>
              </el-form-item>
              <el-form-item label="指定执行用户" v-if="selectElement.type!='node_start' && selectElement.type!='node_end'">
                <el-input v-model="selectElement.data_key_assign_user" placeholder="例如node_create.assign_user_id" autosize maxlength="128"></el-input>
              </el-form-item>
              <el-form-item label="执行者角色" v-if="selectElement.type!='node_end'">
                <el-select v-model="selectElement.roles" filterable clearable multiple placeholder="能执行此节点任务的用户角色">
                  <el-option v-for="item in roleList" :key="item.value" :label="item.label" :value="item.value"/>
                </el-select>
              </el-form-item>
              <el-form-item label="仅创建者领导" v-if="selectElement.type!='node_start' && selectElement.type!='node_end'">
                <el-switch v-model="selectElement.only_leaders"></el-switch>
                <span style="margin-left: 10px;font-size: smaller;color: grey">拥有角色的前提下，仅创建者领导能执行此节点任务</span>
              </el-form-item>
              <el-form-item label="仅直接领导" v-if="selectElement.type!='node_start' && selectElement.type!='node_end'">
                <el-switch v-model="selectElement.only_direct_leaders"></el-switch>
                <span style="margin-left: 10px;font-size: smaller;color: grey">越级的领导不会收到此任务</span>
              </el-form-item>
              <el-form-item label="允许前置加签" v-if="selectElement.type!='node_start' && selectElement.type!='node_end'">
                <el-switch v-model="selectElement.add_pre_node_allowed"></el-switch>
                <span style="margin-left: 10px;font-size: smaller;color: grey">临时添加前置审批节点</span>
              </el-form-item>
              <el-form-item label="允许指派任务" v-if="selectElement.type!='node_start' && selectElement.type!='node_end'">
                <el-switch v-model="selectElement.assign_task_allowed"></el-switch>
                <span style="margin-left: 10px;font-size: smaller;color: grey">指派此任务到任意用户</span>
              </el-form-item>
              <el-form-item label="允许撤销流程" v-if="selectElement.type!='node_start' && selectElement.type!='node_end'">
                <el-switch v-model="selectElement.revoke_allowed"></el-switch>
                <span style="margin-left: 10px;font-size: smaller;color: grey">在此节点中，创建人是否可以撤销整个流程</span>
              </el-form-item>
              <el-form-item label="允许批量审批" v-if="selectElement.type!='node_start' && selectElement.type!='node_end'">
                <el-switch v-model="selectElement.batch_submit_allowed"></el-switch>
                <span style="margin-left: 10px;font-size: smaller;color: grey">在此节点中，是否允许批量审批(通过/驳回)</span>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="表单设置" v-if="selectElement.type!='node_end'">
            <el-form label-width="120px" v-model="jsonData">
              <el-form-item label="输入表单" >
                <el-cascader v-model="selectElement.form_code" :options="formTree" style="width: 100%"
                             :show-all-levels="false" placeholder="系统定义表单" :props="cascaderProps" clearable filterable>
                </el-cascader>
              </el-form-item>
              <el-form-item label="自定义输入" >
                <el-input v-model="selectElement.form_component" placeholder="前端控件路径，自定义优先"  maxlength="64"></el-input>
              </el-form-item>
              <el-form-item label="回显表单" >
                <el-cascader v-model="selectElement.form_code_readonly" :options="formTree" style="width: 100%"
                             :show-all-levels="false" placeholder="系统定义表单" :props="cascaderProps" clearable filterable>
                </el-cascader>
              </el-form-item>
              <el-form-item label="自定义回显" >
                <el-input v-model="selectElement.form_component_readonly" placeholder="前端控件路径，自定义优先"  maxlength="64"></el-input>
              </el-form-item>
              <el-form-item label="显示模式" >
                <el-radio-group v-model="selectElement.show_mode">
                  <el-radio value="dialog">对话框</el-radio>
                  <el-radio value="window">窗口</el-radio>
                </el-radio-group>
                <span style="margin-left: 10px;font-size: smaller;color: grey">默认为对话框</span>
              </el-form-item>
              <el-form-item label="表单宽度" >
                <el-input-number v-model="selectElement.form_width" :min="300" :max="1400" placeholder="窗口宽度" style="width: 180px"></el-input-number>
                <span style="margin-left: 10px;font-size: smaller;color: grey">默认800px</span>
              </el-form-item>
              <el-form-item label="表单高度" >
                <el-input-number v-model="selectElement.form_height" :min="200" :max="1000" placeholder="窗口高度" style="width: 180px"></el-input-number>
                <span style="margin-left: 10px;font-size: smaller;color: grey">默认600px</span>
              </el-form-item>
              <el-form-item label="窗口最大化" >
                <el-switch v-model="selectElement.form_max"></el-switch>
                <span style="margin-left: 10px;font-size: smaller;color: grey">仅在窗口模式生效</span>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="样式" >
              <div v-if="selectElement.style_fill" class="quick-color-selected-item" style="width: 100px;margin-left: 10px"
                   :style="{color:selectElement.style_color,borderColor:selectElement.style_stroke,backgroundColor:selectElement.style_fill}">
                {{ selectElement.style_name || '内容' }}
                <el-icon size="20" @click="clearQuickStyle" class="del">
                  <ElIconCloseBold/>
                </el-icon>
              </div>

              <div class="color-popover-box">
                <div class="item" v-for="(item,index) in colorList" :key="index" @click="selectQuickStyle(item)"
                     :style="{color:item.color,borderColor:item.borderColor,backgroundColor:item.backgroundColor}">{{ item.name }}
                </div>
              </div>
          </el-tab-pane>
        </el-tabs>
      </template>
      <template v-else-if="selectType==='edge'">
        <el-tabs style="height: 100%;background-color: #FFFFFF">
          <el-tab-pane label="路线属性">
            <el-form label-width="120px" v-model="jsonData">
              <el-form-item label="路线名称">
                <el-input v-model="selectElement.text" placeholder="路线名称"></el-input>
              </el-form-item>
              <el-form-item label="条件表达式">
                <el-input v-model="selectElement.condition" placeholder="条件表达式"></el-input>
              </el-form-item>
              <el-form-item label="全部匹配" >
                <el-switch v-model="selectElement.match_all"></el-switch>
                <span style="margin-left: 10px;font-size: smaller;color: grey">仅在会签节点生效</span>
              </el-form-item>
              <el-form-item label="触发器">
                <el-cascader v-model="selectElement.triggers" :options="programTree" style="width: 100%"
                             :show-all-levels="false" placeholder="请选择程序" :props="cascaderPropsMulti" clearable multiple filterable>
                </el-cascader>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="样式" >
            <div v-if="selectElement.style_stroke" class="quick-color-selected-item" style="width: 100px;margin-left: 10px"
                 :style="{color:selectElement.style_color,borderColor:selectElement.style_stroke,backgroundColor:selectElement.style_fill}">
              {{ selectElement.style_name || '内容' }}
              <el-icon size="20" @click="clearQuickStyle" class="del">
                <ElIconCloseBold/>
              </el-icon>
            </div>
            <div class="color-popover-box">
              <div class="item" v-for="(item,index) in colorList" :key="index" @click="selectQuickStyle(item)"
                   :style="{color:item.color,borderColor:item.borderColor,backgroundColor:item.backgroundColor}">{{ item.name }}
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </template>
      <template v-else>
        <el-tabs style="height: 100%;background-color: #FFFFFF">
          <el-tab-pane label="工作流基本属性">
            <el-form label-width="120px" v-model="jsonData">
              <el-form-item label="工作流Code" required>
                <el-input v-model="jsonData.code" placeholder="工作流Code" disabled></el-input>
              </el-form-item>
              <el-form-item label="当前版本" required>
                <el-input v-model="jsonData.version" placeholder="版本号" disabled></el-input>
              </el-form-item>
              <el-form-item label="工作流名称" required>
                <el-input v-model="jsonData.name" placeholder="工作流名称"></el-input>
              </el-form-item>
              <el-form-item label="ID前缀" required>
                <el-input v-model="jsonData.id_prefix" placeholder="ID的前缀，最多6个字" maxlength="6"></el-input>
              </el-form-item>
              <el-form-item label="流程摘要">
                <el-input type="textarea" v-model="jsonData.summary" rows="4" :placeholder="summaryPlaceHolder" maxlength="128"></el-input>
              </el-form-item>
              <el-form-item label="消息推送">
                <el-cascader v-model="jsonData.msg_senders" :options="programTree" style="width: 100%"
                             :show-all-levels="false" placeholder="请选择推送程序" :props="cascaderPropsMulti" clearable multiple filterable>
                </el-cascader>
              </el-form-item>
              <el-form-item label="备注">
                <el-input v-model="jsonData.remark" placeholder="备注" style="width: 100%"></el-input>
              </el-form-item>
              <el-form-item label="">
                <el-button @click="saveFlow" :loading="loading">保存</el-button>
                <el-button @click="onRelease" :loading="loading">发放</el-button>
                <el-button @click="onVersionUp" :loading="loading">升版</el-button>
                <el-button @click="onDelete" >删除</el-button>
                <el-button @click="loadDataSource" >刷新下拉框</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </template>
    </pane>
  </splitpanes>
</template>

<script>
import {Pane, Splitpanes} from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'

import LogicFlow from "@logicflow/core";
import {Control, DndPanel, Menu, MiniMap, SelectionSelect} from "@logicflow/extension";
import "@logicflow/core/lib/style/index.css";
import "@logicflow/extension/lib/style/index.css"
import NodeStart from "./NodeStart";
import NodeNormal from "./NodeNormal.js";
import NodeJudge from "./NodeJudge.js";
import NodeEnd from "./NodeEnd.js";
import PrcPolyline from "./PrcPolyline";

export default {
  name: "FramePrcMaker",
  components: {Splitpanes, Pane},
  inject: ['$fn'],
  props: {
    parentData: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  data() {
    return {
      loading: false,
      lf: null,
      jsonData: {
        id: '',
        code: '',
        version: 0,
        name: '',
        nodes: [],
        edges: []
      },
      summaryPlaceHolder: '例如\r请假天数:${node_create.leave_days}天，请假开始日期:${node_create.start_date}\r出差城市:${node_create.city_name}，拜访客户:${node_create.company_name}',
      selectElement: {properties:{}},
      formInfo: {},
      roleList: [],
      colorList: [
        {
          "backgroundColor": "#FFFFFF",
          "borderColor": "#CCCCCC",
          "color": "#333333",
          "name": "经典简约"
        },
        {
          "backgroundColor": "#F0F0F0",
          "borderColor": "#B0B0B0",
          "color": "#444444",
          "name": "经典浅灰"
        },
        {
          "backgroundColor": "#DCDCDC",
          "borderColor": "#A9A9A9",
          "color": "#2F4F4F",
          "name": "经典深灰"
        },
        {
          "backgroundColor": "#ADD8E6",
          "borderColor": "#87CEFA",
          "color": "#000080",
          "name": "浅蓝经典"
        },
        {
          "backgroundColor": "#C6E2FF",
          "borderColor": "#7EC8E3",
          "color": "#000080",
          "name": "浅天蓝"
        },
        {
          "backgroundColor": "#7FFFD4",
          "borderColor": "#20B2AA",
          "color": "#2F4F4F",
          "name": "海水蓝"
        },
        {
          "backgroundColor": "#F0FFF0",
          "borderColor": "#98FB98",
          "color": "#006400",
          "name": "青苹果绿"
        },
        {
          "backgroundColor": "#98FB98",
          "borderColor": "#32CD32",
          "color": "#006400",
          "name": "现代绿"
        },
        {
          "backgroundColor": "#ADFF2F",
          "borderColor": "#7FFF00",
          "color": "#006400",
          "name": "草地绿"
        },
        {
          "backgroundColor": "#FFFAF0",
          "borderColor": "#F4A300",
          "color": "#000000",
          "name": "暖黄"
        },
        {
          "backgroundColor": "#FFF5EE",
          "borderColor": "#FFD700",
          "color": "#8B4513",
          "name": "米黄"
        },
        {
          "backgroundColor": "#FFF8DC",
          "borderColor": "#D2691E",
          "color": "#000000",
          "name": "玉米黄"
        },
        {
          "backgroundColor": "#FFF0F5",
          "borderColor": "#DB7093",
          "color": "#C71585",
          "name": "玫瑰粉"
        },
        {
          "backgroundColor": "#FFE4E1",
          "borderColor": "#FF6347",
          "color": "#800000",
          "name": "淡红经典"
        },
        {
          "backgroundColor": "#FF69B4",
          "borderColor": "#FF1493",
          "color": "#FFFFFF",
          "name": "热情粉"
        },
        {
          "backgroundColor": "#DDA0DD",
          "borderColor": "#DA70D6",
          "color": "#800080",
          "name": "紫罗兰"
        },
        {
          "backgroundColor": "#9932CC",
          "borderColor": "#8A2BE2",
          "color": "#FFFFFF",
          "name": "紫水晶"
        },
        {
          "backgroundColor": "#8A2BE2",
          "borderColor": "#7B68EE",
          "color": "#FFFFFF",
          "name": "梦幻紫"
        }
      ],
      ctrlKeyPressed: false,
      multipleSelectId: [],
      multipleSelectElement: {},
      formTree:[],
      programTree:[],
      cascaderProps: {
        emitPath:false,
        expandTrigger: 'hover',
        value: 'code',
        label: 'name'
      },
      cascaderPropsMulti: {
        emitPath:false,
        expandTrigger: 'hover',
        value: 'code',
        label: 'name',
        multiple: true
      },
    }
  },
  computed: {
    selectType() {
      if (!this.selectElement) {
        return ''
      }
      if (['node_start', 'node_normal', 'node_judge', 'node_end'].includes(this.selectElement.type)) {
        return 'node'
      }
      if ('prc-polyline' == this.selectElement.type) {
        return 'edge'
      }
      return ''

    }
  },
  async mounted() {
    await this.loadDataSource()

    // 修改
    if (this.parentData.id) {
      let data = await this.$http('sysProcessTemplateService.getById', {id: this.parentData.id})
      try {
        this.jsonData = JSON.parse(data.content) || {};
        this.jsonData.id = this.parentData.id;
      } catch (e) {
        return this.$message.error("解析工作流定义失败");
      }
    }

    this.initFlow()

    // 监听 keydown 事件
    document.addEventListener('keydown', event => {
      // 检查按下的键是否是 Ctrl 键（在 Windows 和 Linux 上）或 Command 键（在 macOS 上）
      if (event.ctrlKey || event.metaKey) {
        // 确保不监听 macOS 上的 Control 键
        if (!(event.metaKey && event.key === 'Control')) {
          this.ctrlKeyPressed = true;
          let elements = this.lf.getSelectElements();
          elements.nodes.forEach(node => this.multipleSelectId.push(node.id))
          elements.edges.forEach(edge => this.multipleSelectId.push(edge.id))
        }
      }
    });

    // 监听 keyup 事件
    document.addEventListener('keyup', event => {
      // 检查释放的键是否是 Ctrl 键（在 Windows 和 Linux 上）或 Command 键（在 macOS 上）
      if ((event.key === 'Control' && !event.metaKey) || event.key === 'Meta') {
        this.ctrlKeyPressed = false;
      }
    });

  },
  methods: {
    async loadDataSource(){
      //数据源初始化
      this.roleList = await this.$http('sysDsService.getRole');
      this.programTree = await this.$http('sysProgramService.getDataSource');
      this.formTree = await this.$http('sysDefineService.getDataSource', {'top_level_code':'process_form', 'config_type':'form'});
    },
    initFlow() {
      this.lf = new LogicFlow({
        container: this.$refs.container,
        grid: 20,
        outline: true,
        plugins: [Control, DndPanel, SelectionSelect, MiniMap, Menu],
        pluginsOptions: {
          miniMap: {
            width: 120,
            height: 150,
            isShowCloseIcon: true,
            topPosition: 70,
            rightPosition: 15
          }
        },
        keyboard: {
          enabled: true,
        },
        multipleSelectKey: 'shift',
        adjustEdgeStartAndEnd: true
      });
      this.lf.register(NodeStart)
      this.lf.register(NodeNormal)
      this.lf.register(NodeJudge)
      this.lf.register(NodeEnd)
      this.lf.register(PrcPolyline)
      this.lf.setDefaultEdgeType('prc-polyline')
      this.lf.setTheme({
        outline: {
          stroke: "red"
        },
      });

      this.lf.extension.dndPanel.setPatternItems([
        {
          type: 'node_start',
          label: '开始',
          icon: 'data:image/png;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQH/2wBDAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQH/wAARCAAtACsDASIAAhEBAxEB/8QAHAAAAgICAwAAAAAAAAAAAAAAAAkHCAQGAgUK/8QANBAAAQQCAgADBAYLAAAAAAAAAwECBAUGBwAICRESExQhIhUxMlFY1hcYGSMlQVeWl6fY/8QAGAEBAAMBAAAAAAAAAAAAAAAABwQGCAX/xAAnEQABBQACAQQCAwEBAAAAAAACAQMEBQYHESEACBIiEzEUMkIVI//aAAwDAQACEQMRAD8A9/HKUZV4i3TDDL+0xi+3fVtuKaZIgWI6fE9g5NBDLimJHkBFc4ziVvTS3CMN43uh2B2IrftKioq5/f3a0/T3U7bOT0sskHILSpiYZQygP9nJjTsysI1BImRCo5rwzK6omWdlEONVKGTDERnk5qObGnT7pVoXFuuWrUznTes82zXJcXqs0yq9zfB8byy5+lsrgRrd1UybkFbYmhwaOJIiU4K+A+PXoSEeegHzp86XKVsxmMZHxz+23jmmdhS9CWaoarLSKuFOlSYde1ZW1hKl28GwYGDDal18ZttmOrrsqSqKYg0XrPu63fJczkuLxbxKzh49pXY0dvrdBvYV9aVUCFZXD1LnqaBX521p5R2ti9X3E512TNSOxBgiqNk4+333f7T7o1/XD/Wm3/yBzmPxOujZSMG3eDEcR7WNUmuNthGjnuRqK8pcCYITEVfmIR7Bsb5ue5rUVUnn9VPq7+G3Qf8Ah7Xn5d5hWfUPqvbVthVyeuWkAR7KDLr5BqzV+F09kEMwBI5S19vVU0O0q5wxkc+JY1syJPgnQcmHJBIEMrZAyOBFIUKo5eAVVEIh0WMMhFV8kgLl20NUTtUFXAQlTr5j32kQ4fu5QSUNF7cnDQVUALGcmNCZInYgTqb15WxJfCuI06oJ9kbPr4rNOKZXjec45TZfh93XZHjOQwQ2VLd1UhkqBYQjovoMAzF+CtcjxHCRGHjSBljSBiOIg2bBxR3hi2VtrrKe0fU+5nyJ0bSuzJU/DyynI8haC2srapmkCiq1QRJDqelvGx2DYNsvIpplawpyI5uPKnv8qGM1lrQR5ZWEBj+HNqbAgRsp1PbQY1rUyjBPqLrkCZH/ADiH0GQjoD0g9Ig8P793k3jyg18uuGntpX/SrNDTg6rwVOlz1rNoNBAbcL7lHYt62X/EJz/0OITDhqqn2qn/ABkJpYvVLHgDa5WWW6MRhGVqeaNEPFc8sUc/7m+2gBair5/O5ifWqcaZRwhVtJT1wVa4NfV18ITmfYUUWIEA1Z5fD0qwaK3y/l5cW/4tmNSr/p5d2MYTitw7PMIyWX6WOeooppkvFXF+VF9LWGycKPevytY5yqqJ8eXv1BlUTOdT6zzOAVpomVYDiGQAI16P+W2oIE5WPVPqKJ5nCMxyNeMrHjI1r2ualrvk/Pwrx06x5ag7TkGFOUfKDMlQ8jLii4v+TKIBqCL/AGBFVP16PsiqRfdBzPHleJFrxjw7Z1aF4I62BZciV08mk/22Fi62LhJ4FwhFf2nqReHDhwi9aN9KK0B/DPFj7g04PmjTtV0V0V7E/dtkvh6YlKxyp8EL7S9lIqfWrmF+5eN14obp2Rud+IX3q2XA8j1NE+u1176zzeEkyLaxKb0hOiezIx663lEb6HOa4aCe1XMVrnN54u80J+PS56G54mV/HHHEKwFf7jNbx9U44Lif5NG3WuxXyides5e2JUfxGysmPNbc81812lOQ+WjrHuR79pk2S/RtE6w/8STwq99fr1oG1Nc0O3db5trLJmuWjzfHLTHppRNa88P3+M8cayiI/wCT32ql+72UFz/NjZkUDnIrUVFURrCi8VjrFigdLa+1LqLb+CYjY2ocRy/Ib+kHKfSSppZIIUQZ9tYDZhrWGeebEiXNKewr/fyVzbAtfEgxYbtuHODlOQp2Xq7CidoszqaKxmxrQ6fVQJk6FFtIrLsZuygrAsayVGlnFeOK8YyVbeY+AONl8BVLfyBw5U7y+p9ZH1m4wWrpqudQt6TAW1bVWc+gsJUae9SWqW1NewZ1c3PitTozZwhdjSlccaeH8poqi/0w+MP+FPQf9xUf/SXMSftTxjLKDNrgdadHUJrCJIhBvIF/jBJ1KWUF4B20Idh2AuIBJdc8iTI7J1Raw3GCxsmtnBV8Urf+HO+PK9eBCQ8Q8Q/IVQh+VHpjHtF7TsHNeQGnaeRMSAk8EKoqotQP2+25iQH7jvcaomKgSDqsM0SiSdL8XGuOW3Wy6/RtmDgL9gMS6X1Szot1hsOsWoD1GWz41xs7O72RmmxbWMZ8sTbaWEYYlICwIjSWAaeMx7jzHJ6ZVxPt5QHOjHAvLp8OHDvR6Cz1V7aaK5eF+zt5bkuU4AI00hH0IMsND9WY8doW48ZkVVGmGm20VUFF9MuKx9Fx/lKHGZmMcSjztezXV7TrpPvk238jdkynyRCkTZkg3pk2QSIUiW+88SIpqif/2Q==',
          text: '开始节点',
          properties: {
            width: 100,
            height: 60,
            rx: 30,
            start: true
          },
        },
        {
          type: 'node_normal',
          label: '执行',
          icon: 'data:image/png;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQH/2wBDAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQH/wAARCAAtACsDASIAAhEBAxEB/8QAGQABAQEBAQEAAAAAAAAAAAAACQAHCAUK/8QAMRAAAAUCAgUMAwEAAAAAAAAAAwQFBgcACBMUAglYd9YVFhcYGThXlpent9gBObUS/8QAGAEAAgMAAAAAAAAAAAAAAAAABQcEBgj/xAA9EQAABgEBBQEHFQAAAAAAAAABAgMEBQYHABESExQhCBUWNZa21tcXGCI3OFFVVldYYXF1dnd4lbGztPD/2gAMAwEAAhEDEQA/APubmid4pt6axB6TA6uaDaU18q1yKlyG5F/HXTqcqqxYjk2ujragFip6KpmMyMVDJ6GWwhDGgMMXDF5k7T6xrxw9tJf4ArA9c/3XWHv8a/x5Kdd8dVO13ZtgP0ejzh2nTH1zGcVQqpabghen0haJO0sk0a1LV9gzapVxSIJvHTlIKQXMo4CWJ1K4EoCkb2BQEA1mKYumcrBlzIFBxu6xRFw9DgqDJrubvXrfLSb5xdULCqJEloG2Q7UiLQ1fVACnZgcQcJhxDiUwhgfafWNeOHtpL/AFXafWNeOHtpL/AABW+dVO13ZtgP0ejzh2rqp2u7NsB+j0ecO1D5nAvwPl3xlpvmpojyXa2+MvZz8SMmekH6/8PTwIXvHtwuFdJ9lw/I3O9ypiAadB5N5oPtAwEIkopSSZPZx0NdETxcJQWkwvlgTQhzTzOKGX0wQTAgXTdDZbs1GsyNbVc812W2kBoNpMgNG5NbrXR05AQk/Op9uqgcyKQkliieUzagbNHjOXLh45wyYMi/7GGE09Jk6EZNrMDWJqHRrR5c0RNVCsWhuSccMnUih3wxiUkLZZdgyj2x+AVUqYCRuHUph3jAICFjwXebde6xZHF4TrhLFV8jXuhvFKoyk2EK77zZxaFB62ay8pLvk+bO3OsIKvTbCmIHDIICAkXrn+66w9/jX+PJTpdKIvXP8AddYe/wAa/wAeSnS6UXtXtO4j+38pfz03VcoHuk+0V90cC/1MlaqqqqUWtGaIuHf3D3Wbg27/AA7baXSiLh39w91m4Nu/w7baXSm7mHwjQ/wixj5LM9Zz7NvgbLf5jM6eXklo6NZxBErXCwK0mXD7V53uVMl1BdB5N5cbaBgIRJmv5JMns46FhETxcJQWkwvlgTQhzTzOKGX0wQTAgWRdMOuH2U4D8xIf2SpdKqhwmUl4qtRdWfUqi2iPhnkq9jVrLHTbp41VmTtTvykUj7BGIcNUWTXpy+8AIl2nMPXRK0YEa2C7z1+icn5XocxZo6AjJttSJmrsIx83rKb9OIOqjL0+cdCs3LJvhE3Obgi4U3UygOzRF9MOuH2U4D8xIf2Sq6YdcPspwH5iQ/slS6VVM9VWO+SDEX6LafPHQ31v8z847tGeM9C9G30fv746Iuz+ILuOufK9ylykVIEe9IURaTXEEa7laikhcupp+KU1JIkUlNfj1Xy2ZQGUZOmTJ0yMTzgRj8fgwWzJMnS6VVVUbrcnt4lm0q9jYiJ5KIi4NnHQaDttHNY6HbA0YoopPn0i4DhNykTETOTAIELsKXrtY2MMaReK6++gIuasdi7p2OetcnM2t3HPZp/NWR6aRlXLlxFxUMzNx3h1FgAjEhgMofeOfaGz/9k=',
          text: '执行节点',
          properties: {
            width: 100,
            height: 60,
          },
        },
        {
          type: 'node_judge',
          label: '审批',
          icon: 'data:image/png;base64,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',
          text: '审批节点',
          properties: {
            rx: 50,
            ry: 30
          },
        },
        {
          type: 'node_end',
          label: '结束',
          text: '结束节点',
          icon: 'data:image/png;base64,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',
          properties: {
            end: true,
            r: 30
          },
        },
        {
          label: '框选',
          icon: 'data:image/png;base64,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',
          callback: () => {
            this.lf.extension.selectionSelect.openSelectionSelect();
            this.lf.once('selection:selected', () => {
              this.lf.extension.selectionSelect.closeSelectionSelect();
            });
          }
        }
      ]);

      let control = this.lf.extension.control || {};
      control.removeItem('undo')
      control.removeItem('redo')
      control.removeItem('reset')
      control.addItem({
        key: 'original-size',
        iconClass: "lf-control-original-size",
        text: '原始尺寸',
        onClick: () => {
          this.lf.resetZoom()
        },
      })
      control.addItem({
        key: 'fit-view',
        iconClass: "lf-control-fit",
        text: '自适应',
        onClick: () => {
          this.lf.fitView()
        },
      })
      control.addItem({
        key: 'center-view',
        iconClass: "lf-control-align-center",
        text: '居中显示',
        onClick: () => {
          this.lf.translateCenter()
        },
      })
      control.addItem({
        key: 'center-view',
        iconClass: "lf-control-initial-position",
        text: '初始位置',
        onClick: () => {
          this.lf.resetTranslate()
        },
      })
      control.addItem({
        key: 'mini-map',
        iconClass: "lf-control-custom-minimap",
        text: '小地图',
        onClick: () => {
          if (this.lf.extension.miniMap.isShow) {
            this.lf.extension.miniMap.hide()
          } else {
            this.lf.extension.miniMap.show()
          }
        },
      })
      control.addItem({
        key: 'undo',
        iconClass: 'lf-control-undo',
        title: '回到上一步',
        text: '上一步',
        onClick: () => {
          this.lf.undo();
        },
      })
      control.addItem({
        key: 'redo',
        iconClass: 'lf-control-redo',
        title: '移到下一步',
        text: '下一步',
        onClick: () => {
          this.lf.redo();
        },
      })
      control.addItem({
        key: 'delete',
        iconClass: "lf-control-custom-delete",
        text: '删除',
        onClick: () => {
          let elements = this.lf.getSelectElements();
          for (let node of elements.nodes) {
            this.lf.deleteNode(node.id)
          }
          for (let edge of elements.edges) {
            this.lf.deleteEdge(edge.id)
          }

        },
      })

      this.lf.extension.menu.setMenuConfig({
        nodeMenu: [{
          text: "删除",
          callback: (node) => {
            this.lf.deleteNode(node.id);
          }
        }],
        edgeMenu: [{
          text: "删除",
          callback: (edge) => {
            this.lf.deleteEdge(edge.id);
          }
        }],
        graphMenu: false,
      });

      this.lf.on("node:click", data => {
        let node = data.data
        this.selectElement = {
          id: node.id,
          type: node.type,
          text: node.text.value,
          start: node.properties.start,
          end: node.properties.end,
          code: node.properties.code,
          in_triggers: node.properties.in_triggers,
          out_triggers: node.properties.out_triggers,
          revoke_triggers: node.properties.revoke_triggers,
          data_key_assign_user: node.properties.data_key_assign_user,
          roles: node.properties.roles,
          assign_to_creator: node.properties.assign_to_creator,
          only_leaders: node.properties.only_leaders,
          only_direct_leaders: node.properties.only_direct_leaders,
          add_pre_node_allowed: node.properties.add_pre_node_allowed,
          assign_task_allowed: node.properties.assign_task_allowed,
          revoke_allowed: node.properties.revoke_allowed,
          batch_submit_allowed: node.properties.batch_submit_allowed,
          form_code: node.properties.form_code,
          form_component: node.properties.form_component,
          form_code_readonly: node.properties.form_code_readonly,
          form_component_readonly: node.properties.form_component_readonly,
          show_mode: node.properties.show_mode,
          form_width: node.properties.form_width,
          form_height: node.properties.form_height,
          form_max: node.properties.form_max,
          multi: node.properties.multi,
          data_key_multi_departments: node.properties.data_key_multi_departments,
          style_fill: node.properties.style_fill,
          style_color: node.properties.style_color,
          style_stroke: node.properties.style_stroke,
          style_name: node.properties.style_name
        }

      })

      this.lf.on("node:add,node:dnd-add,node:delete", () => {
        this.lf.getGraphData();
      })

      this.lf.on("edge:click", data => {
        let edge = data.data
        this.selectElement = {
          id: edge.id,
          type: edge.type,
          text: edge.text?.value,
          condition: edge.properties.condition,
          match_all: edge.properties.match_all,
          triggers: edge.properties.triggers,
          style_stroke: edge.properties.style_stroke,
          style_name: edge.properties.style_name,
        }
      })
      this.lf.on("element:click", (element) => {
        if (this.ctrlKeyPressed) {
          if (!this.multipleSelectId.includes(element.data.id)) {
            this.multipleSelectId.push(element.data.id)
          }
          setTimeout(() => {
            this.multipleSelectId.forEach(id => {
              this.lf.selectElementById(id, true)
            })
            this.calcMultipleSelectElement()
          }, 10)

        } else {
          this.multipleSelectId = []
          this.calcMultipleSelectElement()
        }

      });
      this.lf.on("blank:click", () => {
        this.selectElement = {};
        this.multipleSelectId = []
        this.multipleSelectElement = {}
      })
      this.lf.on("text:update", data => {
        if (data.data.id == this.selectElement.id) {
          this.selectElement.text = data.data.text;
        }
        this.lf.getGraphData()
      })

      this.lf.render(this.jsonData);
      setTimeout(() => {
        this.lf.fitView();
        this.lf.translateCenter()
      }, 200)

      this.lf.adapterOut = (logicFlowData) => {
        this.jsonData.nodes = logicFlowData.nodes;
        this.jsonData.edges = logicFlowData.edges;
        return this.jsonData;
      };
    },
    saveFlow() {
      let flowData = this.lf.getGraphData();
      flowData.id = this.parentData.id;
      flowData.code = this.jsonData.code;
      flowData.name = this.jsonData.name;
      flowData.id_prefix = this.jsonData.id_prefix;
      flowData.summary = this.jsonData.summary;
      flowData.msg_senders = this.jsonData.msg_senders;
      flowData.remark = this.jsonData.remark;

      this.$http('sysProcessTemplateService.save', flowData, false).then(data => {
        this.loading = false;
        this.$message.success("保存成功");
        this.$fn.closeWindow();
        this.$fn.search();
      }, errMsg => {
        this.loading = false;
        return this.$message.error(errMsg);
      })
    },
    clearSkin() {
      let graphData = this.lf.getGraphData();

      for (let node of graphData.nodes) {
        this.lf.deleteProperty(node.id, '')
      }

      for (let edge of graphData.edges) {
        this.lf.deleteProperty(edge.id, 'skin_stroke')
      }
    },
    selectQuickStyle(item) {
      if (this.selectType == 'edge') {
        this.selectElement.style_stroke = item.backgroundColor
      } else {
        this.selectElement.style_color = item.color
        this.selectElement.style_fill = item.backgroundColor
        this.selectElement.style_stroke = item.borderColor
      }
      this.selectElement.style_name = item.name
    },
    clearQuickStyle() {
      delete this.selectElement.style_color
      delete this.selectElement.style_fill
      delete this.selectElement.style_stroke
      delete this.selectElement.style_name

      this.lf.deleteProperty(this.selectElement.id, 'style_color')
      this.lf.deleteProperty(this.selectElement.id, 'style_fill')
      this.lf.deleteProperty(this.selectElement.id, 'style_stroke')
      this.lf.deleteProperty(this.selectElement.id, 'style_name')
    },
    calcMultipleSelectElement() {
      let set = new Set();
      let elements = this.lf.getSelectElements();
      elements.nodes.forEach(node => {
        set.add(node.properties?.style_name)
      })
      elements.edges.forEach(edge => {
        set.add(edge.properties?.style_name)
      })
      if (set.size != 1) {
        this.multipleSelectElement = {}
      } else {
        let styleName = [...set][0];

        let item = this.colorList.find(item => item.name === styleName);
        this.multipleSelectElement = item || {}
      }

    }
  },
  watch: {
    selectElement: {
      handler(element) {
        this.lf.updateText(element.id, element.text)
        if (this.selectType === 'node') {
          this.lf.setProperties(element.id, {
            start: element.start,
            end: element.end,

            code: element.code,
            name: element.name,
            in_triggers: element.in_triggers,
            out_triggers: element.out_triggers,
            revoke_triggers: element.revoke_triggers,
            data_key_assign_user: element.data_key_assign_user,
            roles: element.roles,
            assign_to_creator: element.assign_to_creator,
            only_leaders: element.only_leaders,
            only_direct_leaders: element.only_direct_leaders,
            add_pre_node_allowed: element.add_pre_node_allowed,
            assign_task_allowed:element.assign_task_allowed,
            revoke_allowed: element.revoke_allowed,
            batch_submit_allowed: element.batch_submit_allowed,
            form_code: element.form_code,
            form_component: element.form_component,
            form_code_readonly: element.form_code_readonly,
            form_component_readonly: element.form_component_readonly,
            show_mode: element.show_mode,
            form_width: element.form_width,
            form_height: element.form_height,
            form_max: element.form_max,

            multi: element.multi,
            data_key_multi_departments:element.data_key_multi_departments,

            style_fill: element.style_fill,
            style_color: element.style_color,
            style_stroke: element.style_stroke,
            style_name: element.style_name,
          })
        } else if (this.selectType == 'edge') {
          this.lf.setProperties(element.id, {
            condition: element.condition,
            match_all: element.match_all,
            triggers: element.triggers,
            style_stroke: element.style_stroke,
            style_name: element.style_name,
          })
        }
        this.lf.getGraphData()
      },
      deep: true
    }
  }
}
</script>

<style lang="less">
.lf-control-custom-delete {
  background-image: url("../assets/icon/delete.png");
}

.lf-control-initial-position {
  background-image: url("../assets/icon/initial-position.png");
}

</style>

<style scoped lang="less">
.container {
  width: 100%;
  height: 100%;
}

.container :deep(.lf-control-item) {
  padding: 5px 8px;
}

.container :deep(.lf-control-item i) {
  height: 18px;
  width: 18px;
}

.container :deep(.lf-control-item .lf-control-text) {
  font-size: 10px;
}

.container :deep(.lf-multiple-select) {
  visibility: hidden;
}

.el-tab-pane {
  padding-right: 20px;
}

.color-popover-box {
  overflow: auto;
  display: flex;
  flex-wrap: wrap;
  max-height: 600px;

  .item {
    width: 100px;
    border-radius: 5px;
    padding: 10px;
    border: 2px solid;
    text-align: center;
    margin: 10px;
  }

}

.quick-color-selected-item {
  width: 100px;
  border-radius: 5px;
  padding: 10px;
  border: 2px solid;
  text-align: center;
  position: relative;

  .del {
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
  }
}


</style>